import { ILocale } from '@ng-omar/translation';

export const locale: ILocale = {
    code: 'en',
    strings: {
        'translate_all_rights_reserved_to_syscodeia_for_it_solutions_year':
            'All rights are reserved to SYSCODEIA I.T. SOLUTION {{year}}©.',
        'translate_feature_not_available': 'Feature Not Available',
        'translate_feature_not_available_contact_us':
            'This feature is not included in your current license. To enable it, please contact us at info@syscodeia.ae',
        'translate_pending_initial_review': 'Pending Initial Review',
        'translate_pending_lead_coordinator_decision':
            'Pending Lead Coordinator Decision',
        'translate_pending_committee_evaluation':
            'Pending Innovation Committee Evaluation',
        'translate_pending_organizational_unit_evaluation':
            'Pending Organizational Unit Evaluation',
        'translate_pending_execution': 'Pending Execution',
        'translate_pending_planned_execution': 'Pending Planned Execution',
        'translate_pending_appealed': 'Pending Appeals',
    },
};
